export const environment = {
  production: true,
  env: 'uat'
};
